import { render, staticRenderFns } from "./date-picker.vue?vue&type=template&id=fc87a89c"
import script from "./date-picker.vue?vue&type=script&lang=ts"
export * from "./date-picker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports